export default "__VITE_ASSET__CSnb0D8R__"